import React, { useState } from 'react';
import { SearchIcon, ChevronRightIcon, ArrowUpDownIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, FileIcon } from 'lucide-react';
import { BulkPaymentBatch } from '../pages/BulkPayments';
interface BulkPaymentListSimplifiedProps {
  onViewDetail: (batchId: string) => void;
}
export function BulkPaymentListSimplified({
  onViewDetail
}: BulkPaymentListSimplifiedProps) {
  // Mock recent batch data - showing only the 3 most recent
  const recentBatches: BulkPaymentBatch[] = [{
    id: '1',
    name: 'December Invoices',
    createdAt: '2023-12-15T09:30:00',
    totalAmount: 12450.75,
    currency: 'USD',
    totalItems: 45,
    completedItems: 38,
    status: 'completed',
    collectionRate: 84.4
  }, {
    id: '4',
    name: 'Membership Renewals',
    createdAt: '2023-12-18T16:20:00',
    totalAmount: 3600.0,
    currency: 'USD',
    totalItems: 12,
    completedItems: 5,
    status: 'processing',
    collectionRate: 41.7
  }, {
    id: '5',
    name: 'Workshop Registrations',
    createdAt: '2023-12-10T08:30:00',
    totalAmount: 2250.0,
    currency: 'USD',
    totalItems: 15,
    completedItems: 15,
    status: 'completed',
    collectionRate: 100.0
  }];
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'completed':
        return <CheckCircleIcon size={16} className="text-green-500" data-id="element-1236" />;
      case 'processing':
        return <ClockIcon size={16} className="text-blue-500" data-id="element-1237" />;
      case 'failed':
        return <AlertCircleIcon size={16} className="text-red-500" data-id="element-1238" />;
      default:
        return <FileIcon size={16} className="text-gray-500" data-id="element-1239" />;
    }
  };
  return <div className="overflow-x-auto" data-id="element-1240">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-1241">
        <thead className="bg-gray-50" data-id="element-1242">
          <tr data-id="element-1243">
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1244">
              Batch Name
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1245">
              Created
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1246">
              Total Amount
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1247">
              Status
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1248">
              Collection
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1249">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-1250">
          {recentBatches.map(batch => <tr key={batch.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => onViewDetail(batch.id)} data-id="element-1251">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-1252">
                <div className="text-sm font-medium text-gray-900" data-id="element-1253">
                  {batch.name}
                </div>
                <div className="text-xs text-gray-500" data-id="element-1254">
                  {batch.totalItems} requests
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1255">
                {formatDate(batch.createdAt)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-1256">
                <div className="text-sm font-medium text-gray-900" data-id="element-1257">
                  {batch.currency} {batch.totalAmount.toFixed(2)}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-1258">
                <div className="flex items-center" data-id="element-1259">
                  {getStatusIcon(batch.status)}
                  <span className="ml-1.5 text-sm text-gray-700 capitalize" data-id="element-1260">
                    {batch.status}
                  </span>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-1261">
                <div className="flex items-center" data-id="element-1262">
                  <div className="w-full bg-gray-200 rounded-full h-2 mr-2 max-w-[100px]" data-id="element-1263">
                    <div className={`h-2 rounded-full ${batch.collectionRate >= 80 ? 'bg-green-500' : batch.collectionRate >= 50 ? 'bg-yellow-500' : 'bg-red-500'}`} style={{
                  width: `${batch.collectionRate}%`
                }} data-id="element-1264"></div>
                  </div>
                  <span className="text-sm text-gray-700" data-id="element-1265">
                    {batch.collectionRate}%
                  </span>
                </div>
                <div className="text-xs text-gray-500 mt-1" data-id="element-1266">
                  {batch.completedItems} of {batch.totalItems} paid
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1267">
                <button className="text-blue-600 hover:text-blue-900" onClick={e => {
              e.stopPropagation();
              onViewDetail(batch.id);
            }} data-id="element-1268">
                  <ChevronRightIcon size={18} data-id="element-1269" />
                </button>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}